import React from "react";
import { styled, css } from "styled-components";
import Colors from "../../styles/Colors";
import { InputText } from "../Text";
import idGenerator from "../../utils/idGenerator";
const StyledRadioButton = styled.label `
  display: flex;
  align-items: center;
  ${({ hasIcon }) => hasIcon &&
    css `
      position: relative;
      padding: 1rem;
    `}

  &,
  > * {
    cursor: ${({ isDisabled }) => (isDisabled ? "not-allowed" : "pointer")};
  }

  &:hover {
    > input:not(:disabled),
    > input:not(:disabled):checked {
      box-shadow: inset 0 0 0 1px ${Colors.LIGHT_RED_2024}, 0 0 0 4px ${Colors.LIGHT_RED_2024};

      &,
      + div[aria-hidden="true"] {
        background-color: ${Colors.WHITE_2024};
      }

      + div[aria-hidden="true"] {
        background-color: ${Colors.LIGHT_RED_2024};
        box-shadow: inset 0 0 0 1px ${Colors.WHITE_2024};
      }
    }
  }

  > input {
    position: relative;
    appearance: none;
    border: none;
    padding: 0;
    margin: ${({ hasIcon }) => (hasIcon ? "0" : "0 0.75rem 0 0")};
    width: 1.5rem;
    height: 1.5rem;
    min-width: 1.5rem;
    min-height: 1.5rem;
    box-shadow: inset 0 0 0 1px ${Colors.GRAY};

    + div[aria-hidden="true"] {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      pointer-events: none;
      box-shadow: inset 0 0 0 1px ${Colors.GRAY};
      border-radius: 0.25rem;
      z-index: -1;
      ${({ isChecked }) => isChecked &&
    css `
          background: ${Colors.LIGHT_RED_2024};
        `}
    }

    &,
    &::after {
      border-radius: 50%;
    }

    &::after {
      position: absolute;
      content: "";
      top: 0.375rem;
      left: 0.375rem;
      width: 0.75rem;
      height: 0.75rem;
      background-color: transparent;
    }

    &:not(:disabled) {
      &:checked {
        box-shadow: inset 0 0 0 1px ${Colors.LIGHT_RED_2024};

        &::after {
          background-color: ${Colors.LIGHT_RED_2024};
        }

        + div[aria-hidden="true"] {
          box-shadow: inset 0 0 0 1px ${Colors.LIGHT_RED_2024};
        }
      }
    }

    &:disabled {
      opacity: 0.5;

      + div[aria-hidden="true"] {
        background-color: ${Colors.GRAY};
        box-shadow: inset 0 0 0 1px ${Colors.GRAY};
      }

      ~ ${InputText.toString()} {
        color: ${Colors.GRAY};
      }
    }
  }

  ${InputText.toString()} {
    position: relative;
    top: 1px;
  }
`;
const IconContainer = styled.span `
  margin: 0 0.625rem;

  svg {
    display: block;
  }
`;
export const RadioButton = ({ id, label, title, disabled, icon: Icon, ...props }) => {
    const [inputId] = React.useState(() => id || idGenerator("fjordline-radio-"));
    const inputRef = React.useRef(null);
    return (React.createElement(StyledRadioButton, { title: title, hasIcon: !!Icon, isDisabled: disabled ?? false, isChecked: inputRef.current?.checked ?? false, htmlFor: inputId },
        React.createElement("input", { id: inputId, type: "radio", title: title, disabled: disabled, ref: inputRef, ...props }),
        Icon && (React.createElement(React.Fragment, null,
            React.createElement("div", { "aria-hidden": "true" }),
            React.createElement(IconContainer, null,
                React.createElement(Icon, { width: 24, height: 24 })))),
        label && React.createElement(InputText, null, label)));
};
export default RadioButton;
//# sourceMappingURL=RadioButton.js.map